'use strict';

function create(type, id) {
  const elem = document.createElement(type);
  elem.id = id;
  return elem;
}

function headTag() {
  return document.getElementsByTagName('head')[0];
}
function bodyTag() {
  return document.getElementsByTagName('body')[0];
}

function append(parent, child) {
  parent.appendChild(child);
}

function cssTag(href) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = href;
  link.media = 'all';
  this.append(headTag(), link);
}

function remove(id) {
  const elem = document.getElementById(id);
  elem.parentNode.removeChild(elem);
}

export {create, headTag, bodyTag, append, cssTag, remove};



// WEBPACK FOOTER //
// ./modules/element.js